module.exports = __webpack_public_path__ + "static/media/eildh.8140ef8a.jpg";